export const isValidNIR = (
  value?: string,
  birthday?: string,
  sexe?: string
) => {
  if (!value || value.length !== 15) return false;
  if (!/^[12]\d{14}$/.test(value)) return false;

  const nirSex = value[0];
  const nirYear = value.substring(1, 3);
  const nirMonth = value.substring(3, 5);

  const monthNum = Number(nirMonth);
  if (monthNum < 1 || monthNum > 12) return false;

  if (!birthday) return true;

  const date = new Date(birthday);
  if (isNaN(date.getTime())) return false;

  const birthYear = date.getFullYear().toString().slice(-2);
  const birthMonth = String(date.getMonth() + 1).padStart(2, "0");

  if (nirYear !== birthYear) return false;
  if (nirMonth !== birthMonth) return false;

  if (sexe) {
    const expectedSex = sexe === "homme" ? "1" : sexe === "femme" ? "2" : null;
    if (expectedSex && nirSex !== expectedSex) return false;
  }

  return true;
};
